import { Checkbox } from '@fluentui/react';
import { Label, ProgressIndicator, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { DataContact } from '../../data/DataContact';
import { Immocom } from '../../specifique/immocom';

export class CheckboxesAcquereurs extends Component {

    static defaultProps = {
        disabled: false,
        idOperation: undefined,
        idReservation: undefined,
        onChange: (selectedKeys, selectedContacts) => console.warn(`Methode non implémentée ; selectedKeys = ${selectedKeys}`),
        selectedKeys: [],
    };

    static defaultState = {
        acquereurs: [],
    };

    constructor(props) {
        super(props);
        this.state = { ...CheckboxesAcquereurs.defaultState };
    };

    _chargementDonnees = () => {
        const { idOperation, idReservation, onChange } = this.props;
        this.setState({ acquereurs: [] })

        !!idOperation && !!idReservation && DataContact._onRechargementContactDeLaReservation(idOperation, idReservation).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const acquereurs = responseFetch.reponseAPIobjet;
                const selectedKeys = acquereurs.map(contact => contact.idContact);
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { acquereurs }, true, () => onChange(selectedKeys, acquereurs));
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _getSelectedContacts = (selectedKeys) => {
        return this.state.acquereurs.filter((contact, index) => selectedKeys.some(key => key === contact.idContact));
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { idReservation } = this.props;
        if (prevProps.idReservation !== idReservation) this._chargementDonnees();
    };

    render = () => {
        const { idOperation, idReservation, selectedKeys, onChange, disabled } = this.props;
        const { acquereurs } = this.state;

        if (!idOperation) return <div>Aucune opération sélectionnée</div>;
        if (!idReservation) return <div>Aucune réservation sélectionnée</div>;

        let checkboxes = <ProgressIndicator />;
        if (!!acquereurs && acquereurs.length) {
            checkboxes = acquereurs.map((contact, index) => {
                const { idContact, nom, prenom } = contact;
                const checked = selectedKeys.some(key => key == idContact);

                return <Checkbox
                    checked={checked}
                    disabled={disabled}
                    key={index}
                    label={`${prenom} ${nom}`.trim()}
                    onChange={(event, checked) => {
                        let selectedKeys = [...this.props.selectedKeys];
                        if (checked) selectedKeys.push(idContact);
                        else selectedKeys = selectedKeys.filter(key => key != idContact);
                        onChange(selectedKeys, this._getSelectedContacts(selectedKeys));
                    }}
                />;
            });
        }

        return <Stack>
            <Label disabled={disabled}>Acquéreurs</Label>
            {checkboxes}
        </Stack>;
    };

}